// 쿠키 + URL 토큰 기반 세션 관리.

const COOKIE_KEY = 'allsteel_chat_sid';
const INQUIRY_KEY = 'allsteel_chat_inquiry_id';
const COOKIE_TTL_DAYS = 30;

export function getOrCreateSessionId(): string {
  const existing = readCookie(COOKIE_KEY);
  if (existing) return existing;
  const sid = uuid();
  writeCookie(COOKIE_KEY, sid, COOKIE_TTL_DAYS);
  return sid;
}

export function getStoredInquiryId(): string | null {
  return readCookie(INQUIRY_KEY);
}

export function setStoredInquiryId(id: string | null): void {
  if (id) writeCookie(INQUIRY_KEY, id, COOKIE_TTL_DAYS);
  else clearCookie(INQUIRY_KEY);
}

/** URL ?chat_t={token} 추출. 있으면 history 에서 제거(URL 깨끗하게).
 *  (legacy: ?t= 도 호환 — 옛 SMS 링크 안전망)
 */
export function consumeResumeToken(): string | null {
  if (typeof window === 'undefined') return null;
  const url = new URL(window.location.href);
  const t = url.searchParams.get('chat_t') || url.searchParams.get('t');
  if (!t) return null;
  url.searchParams.delete('chat_t');
  url.searchParams.delete('t');
  try {
    window.history.replaceState({}, '', url.toString());
  } catch (_) {
    /* ignore */
  }
  return t;
}

function readCookie(key: string): string | null {
  if (typeof document === 'undefined') return null;
  const all = document.cookie.split(';').map((s) => s.trim());
  for (const c of all) {
    const eq = c.indexOf('=');
    if (eq === -1) continue;
    if (c.slice(0, eq) === key) return decodeURIComponent(c.slice(eq + 1));
  }
  return null;
}

function writeCookie(key: string, value: string, days: number): void {
  if (typeof document === 'undefined') return;
  const exp = new Date(Date.now() + days * 86400000).toUTCString();
  document.cookie = `${key}=${encodeURIComponent(value)}; expires=${exp}; path=/; SameSite=Lax`;
}

function clearCookie(key: string): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

function uuid(): string {
  // RFC4122 v4 (crypto.randomUUID 우선, 폴백 random)
  if (typeof crypto !== 'undefined' && (crypto as any).randomUUID) {
    return (crypto as any).randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
